<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close #closeButton>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content >
    <div class="row" *ngIf="bookingsData.length>0">
        <div class="col-sm-4" *ngFor="let item of bookingsData">
            <div class="fl_orders" (click)="selectBooking(item)">
                <div class="top_section_order">
                    <div class="row">
                        <div class="col-sm-3">
                          <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                            <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon>
                          </div>
                            <div class="ads_sec">
                                <div class="hm_icon_progr" style="width: 50px;
                                text-align: center;
                                height: 50px;
                                font-size: 24px;
                                padding-top: 15px;
                                background: #303030;
                                border-radius: 50px;
                                color: #fff;
                                font-weight: bold;;">
                                    {{item.appointment_no}}
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="order_dec">
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;
                                ">{{item.customer_name}}</h3>
                                <p *ngIf="item.servicesArray && item.servicesArray != ''">{{
                                  item.servicesArray.length > 25
                                    ? item.servicesArray.substring(0, 25) + "..."
                                    : item.servicesArray
                                }}
                                </p>
                                <p *ngIf="!item.servicesArray || item.servicesArray == ''">No services added
                                </p>
                                <p>{{item.customer_phone}}
                                </p>
                                <p>Status: <span style="color: #333;">{{item.bookingStat}}</span>  
                                </p>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="bookingsData.length == 0 && !loading">
      <div class="booking_list_placeholder" style="padding: 50px 0px; text-align: center;">
        <div class="booking_list_wer">
           <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M436 392V45c0-24.813-20.187-45-45-45H61C36.187 0 16 20.187 16 45v75h60v347c0 24.813 20.187 45 45 45h330c24.813 0 45-20.187 45-45v-75h-60zM76 90H46V45c0-8.271 6.729-15 15-15s15 6.729 15 15v45zm60 377c0 8.271-6.729 15-15 15s-15-6.729-15-15V45a44.79 44.79 0 0 0-2.58-15H391c8.271 0 15 6.729 15 15v347H136v75zm330 0c0 8.271-6.729 15-15 15H163.43a44.81 44.81 0 0 0 2.57-15v-45h300v45z" fill="#808080" opacity="1" data-original="#000000" class=""></path><path d="M226 106h120v30H226zM226 196h120v30H226zM226 286h120v30H226zM166 106h30v30h-30zM166 196h30v30h-30zM166 286h30v30h-30z" fill="#808080" opacity="1" data-original="#000000" class=""></path></g></svg>
        </div>
        <h2 class="bookingrt">No bookings to show</h2>
      </div>
    </div>
    <div class="row" *ngIf="loading">
      <div style="padding: 50px 0px; text-align: center;" class="placeholder_td">
        <p>Please wait while we load the bookings.</p>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      [disabled]="
      selectedBookingList.length == 0" mat-flat-button color="accent" (click)="onSelectNext()">
      Confirm
    </button>
  </mat-dialog-actions>
  